var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAds)?_c('div',{staticClass:"grey lighten-3",staticStyle:{"width":"100%","min-height":"90px"}},[_c('div',{attrs:{"id":_vm.adUnitDivId}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }